export const addNewElement = (oldArray: string[], newElem: string) => {
    return oldArray.indexOf(newElem) !== -1 ? oldArray : [...oldArray, newElem];
};

export const getId = (type: string) => `id__${type}__${Math.random().toString(36).substr(2, 9)}`;
export const cancelEvent = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
};


// WEBPACK FOOTER //
// ./src/utils/utils.ts